import { ReactNode } from 'react'

interface AppBarProps {
  title: ReactNode
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  transparent?: boolean
  variant?: 'list' | 'detail'
}

export default function AppBar({
  title,
  leftIcon,
  rightIcon,
  transparent = false,
  variant = 'list'
}: AppBarProps) {
  return (
    <div
      className={`sticky top-0 z-50 ${
        transparent
          ? 'bg-transparent'
          : 'bg-white shadow-sm'
      }`}
      style={{
        paddingTop: 'env(safe-area-inset-top)',
      }}
    >
      <div className="px-4 h-[62px] flex items-center justify-between text-[#333]">
        <div className="flex items-center ">
          {leftIcon}
          <div className={`font-['Mulish'] font-black ${
            variant === 'list' 
              ? 'text-[24px] leading-[120%]' 
              : 'text-[18px] leading-[120%]'
          } text-[#333] overflow-hidden text-ellipsis`}>
            {title}
          </div>
        </div>
        {rightIcon}
      </div>
    </div>
  )
} 